import store from './index';
export const selectDistricts = () => store((state) => state.districts);
export const selectFetchedDistrict = () => store((state) => state.district);
export const selectSelectedDistrict = () => store((state) => state.selected);
export default {
    setSelected: store.getState().setSelected,
    getDistricts: store.getState().getDistricts,
    getDistrictAdmin: store.getState().getDistrictAdmin,
    getDistrict: store.getState().getDistrict,
    createDistrict: store.getState().createDistrict,
    addDistrict: store.getState().addDistrict,
    editDistrict: store.getState().editDistrict,
    deleteDistrict: store.getState().deleteDistrict,
    getDistrictDevelopers: store.getState().getDistrictDevelopers,
    getDistrictImages: store.getState().getDistrictImages,
};
